// 仓库设置 新增&添加
export const addOrEditBrandRules = {
  storageAddress: [
    { required: true, message: '请输入详细地址', trigger: 'blur' }
  ],
  storageAdmin: [
    { required: true, message: '请输入联系人', trigger: 'blur' }
  ],
  storageName: [
    { required: true, message: '请输入仓库名称', trigger: 'blur' }
  ],
  storagePhone: [
    { required: true, message: '请输入联系方式', trigger: 'blur' }
  ]
}

// 货架管理 修改货架信息
export const addShelfBankRules = {
  shelvesName: [
    { required: true, message: '请输入货架名称', trigger: 'blur' }
  ]
}
// 库存盘点 盘点页面 盘点对话框 备注信息不能为空
export const postscriptRules = {
  mark: [
    { required: true, message: '备注信息不能为空', trigger: 'blur' }
  ]
}

// 物流/快递发货 撤销快递物流单 revocationRules
export const revocationRules = {
  logicType: [
    { required: true, message: '快递公司', trigger: 'blur' }
  ],
  orderType: [
    { required: true, message: '下单模式不能为空', trigger: ['change', 'blur'] }
  ],
  Mark: [
    { required: true, message: '备注不能为空', trigger: 'blur' }
  ],
  mailNos: [
    { required: true, message: '单号不能为空', trigger: 'blur' }
  ],
  productType: [
    { required: true, message: '产品类型不能为空', trigger: ['change', 'blur'] }
  ],
  transportType: [
    { required: true, message: '运输方式不能为空', trigger: ['change', 'blur'] }
  ],
  deliveryType: [
    { required: true, message: '送货方式不能为空', trigger: 'change' }
  ],
  totalNumber: [
    { required: true, message: '总件数不能为空', trigger: 'blur' }
  ],
  totalWeight: [
    { required: true, message: '总重量不能为空', trigger: 'blur' }
  ],
  payType: [
    { required: true, message: '支付方式不能为空', trigger: 'blur' }
  ],
  backSignBill: [
    { required: true, message: '签收回单不能为空', trigger: 'blur' }
  ]
}

// 待备货 revocationRulesG
export const deliverGoodsRules = {
  logicType: [
    { required: true, message: '快递公司', trigger: ['change', 'blur'] }
  ],
  orderType: [
    { required: true, message: '下单模式不能为空', trigger: ['change', 'blur'] }
  ],
  Mark: [
    { required: true, message: '备注不能为空', trigger: 'blur' }
  ],
  mailNos: [
    { required: true, message: '单号不能为空', trigger: 'blur' }
  ],
  productType: [
    { required: true, message: '产品类型不能为空', trigger: 'change' }
  ],
  transportType: [
    { required: true, message: '运输方式不能为空', trigger: 'change' }
  ],
  deliveryType: [
    { required: true, message: '送货方式不能为空', trigger: 'change' }
  ],
  totalNumber: [
    { required: true, message: '总件数不能为空', trigger: 'change' }
  ],
  payType: [
    { required: true, message: '支付方式不能为空', trigger: 'change' }
  ],
  backSignBill: [
    { required: true, message: '签收回单不能为空', trigger: 'change' }
  ]
}
// 待审核盘点任务详情备注
export const remarkRules = {
  mark: [
    { required: true, message: '     ' }
  ]
}

// 库存盘点 新增
export const addRules = {
  sbId: [
    { required: true, message: '仓库不能为空 ', trigger: ['change', 'blur'] }
  ],
  inventoryName: [
    { required: true, message: '盘点名称不能为空 ', trigger: ['change', 'blur'] }
  ]
}

// 实时库存查询 盘点校验
export const checkRules = {
  afterCount: [
    { required: true, message: '盘点后数量不能为空 ', trigger: ['change', 'blur'] }
  ],
  difference: [
    { required: true, message: '差异数量不能为空 ', trigger: ['change', 'blur'] }
  ],
  mark: [
    { required: true, message: '备注不能为空 ', trigger: ['change', 'blur'] }
  ]
}
